import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { KnowledgeSource } from '@vendasta/embeddings';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { AiKnowledgeService } from '../ai-knowledge.service';
import { AiKnowledgeI18nModule } from '../assets/i18n/ai-knowledge-i18n.module';

@Component({
  selector: 'ai-knowledge-knowledge-list',
  standalone: true,
  imports: [CommonModule, TranslateModule, AiKnowledgeI18nModule, MatIconModule, MatListModule],
  templateUrl: './knowledge-list.component.html',
  styleUrls: ['./knowledge-list.component.scss'],
})
export class KnowledgeListComponent {
  @Input()
  get knowledgeSources(): KnowledgeSource[] {
    return this._knowledgeSources;
  }
  set knowledgeSources(sources: KnowledgeSource[]) {
    this._knowledgeSources = (sources || []).sort((a, b) => {
      if (a?.config?.businessProfileConfig?.accountGroupId) {
        return -1;
      }
      if (b?.config?.businessProfileConfig?.accountGroupId) {
        return 1;
      }
      return a?.name?.localeCompare(b?.name) || 0;
    });
  }
  _knowledgeSources: KnowledgeSource[];

  @Input() allowRemoveBusinessProfile: boolean;
  @Output() titleClicked = new EventEmitter<KnowledgeSource>();
  @Output() removeClicked = new EventEmitter<KnowledgeSource>();

  private readonly knowledgeService = inject(AiKnowledgeService);

  getKnowledgePreview(source: KnowledgeSource): string {
    return this.knowledgeService.getKnowledgePreview(source);
  }

  clickTitle(source: KnowledgeSource): void {
    this.titleClicked.emit(source);
  }

  clickRemove(source: KnowledgeSource): void {
    this.removeClicked.emit(source);
  }

  canRemoveSource(source: KnowledgeSource): boolean {
    if (source?.config?.businessProfileConfig?.accountGroupId) {
      return this.allowRemoveBusinessProfile;
    }
    return true;
  }
}
